import React from 'react';
import { ContentProps } from '../../models/TopLevelTemplateComponentProps';
import { Palette } from 'Palette';
import sanitizeHTML from '../../services/sanitizeHTML';
import { contentNotSet } from '../../services/TemplateUtils';
import LinkifiedHtml from '../LinkifiedHtml';
import StyledSection from '../styles/StyledSection';
import { StyledTypography } from '../styles/styles';

export interface TextBlockProps {
  content: ContentProps;
  id?: string;
  tone?: keyof typeof Palette;
  firstElement?: boolean;
}

/**
 * A single rich-text body with no heading. Styled on its own (`text-block`) so it
 * can diverge from StandardHeaderText; it starts out matching that block's body.
 */
export default function TextBlock({ content, id, tone = 'tone1', firstElement }: TextBlockProps) {
  if (!content || contentNotSet(content)) return null;
  return (
    <StyledSection
      id={id}
      noSidePaddingFrom="xs"
      noTopPadding={!firstElement}
      tone={tone}
      additionalClassName="text-block-section content-management-item"
    >
      <LinkifiedHtml
        as={StyledTypography}
        className="text-block"
        html={sanitizeHTML(content.content)}
      />
    </StyledSection>
  );
}
